import { getAnalyticsErrorType } from '@zg-rentals/rentals-analytics';
import { logError } from '@zg-rentals/log-error';
import type { ZrmClickstreamUser, ZrmUserInfo } from './types';

const nullValues = {
  zrm_user_info: {
    multi_family_customer_ind: null,
    single_family_enterprise_customer_ind: null,
    active_listing_cnt: null,
    total_listing_cnt: null,
  },
};

export function getZrmUserInfo(user?: ZrmClickstreamUser | null): ZrmUserInfo {
  try {
    if (!user) {
      return nullValues;
    }
    const {
      summary = {},
      isMultifamilyCustomer = false,
      isSingleFamilyEnterpriseCustomer = false,
      impersonatorUserToken,
    } = user;
    return {
      zrm_user_info: {
        multi_family_customer_ind: Boolean(isMultifamilyCustomer),
        single_family_enterprise_customer_ind: Boolean(isSingleFamilyEnterpriseCustomer),
        ...(typeof summary.activeListingCount !== 'undefined' && {
          active_listing_cnt: Number(summary.activeListingCount),
        }),
        ...(typeof summary.totalListingCount !== 'undefined' && {
          total_listing_cnt: Number(summary.totalListingCount),
        }),
        ...(impersonatorUserToken && {
          impersonator_zuid: String(impersonatorUserToken),
        }),
      },
    };
  } catch (error) {
    logError({ error, errorType: getAnalyticsErrorType('getZrmUserInfo'), context: { argumentPassed: user } });
    return nullValues;
  }
}
